import toast from "react-hot-toast";
import { IoMdInformationCircle } from "react-icons/io";

export const lightSuccessToast = (message) =>
  toast.success(message, { duration: 1500 });

export const darkSuccesToast = (message) =>
  toast.success(message, {
    duration: 1500,
    style: {
      backgroundColor: "#2C4861",
      color: "#fff",
    },
  });

export const lightErrorToast = (message) =>
  toast.error(message, { duration: 1500 });

export const darkErrorToast = (message) =>
  toast.error(message, {
    duration: 1500,
    style: {
      backgroundColor: "#2C4861",
      color: "#fff",
    },
  });

export const lightInfoToast = (message) =>
  toast.error(message, {
    duration: 1500,
    icon: <IoMdInformationCircle size={24} color="#2C4861" />,
  });

export const darkInfoToast = (message) =>
  toast.error(message, {
    duration: 1500,
    icon: <IoMdInformationCircle size={24} color="#fff" />,
    style: {
      backgroundColor: "#2C4861",
      color: "#fff",
    },
  });
